<template>
    <button @click="clicked" :type="type" :disabled="isDisabled">
        <template v-if="!title">
            <i v-if="loading" class='fa fa-refresh fa-spin fa-fw'></i>
            <slot v-else></slot>
        </template>
        <span v-else v-html="currentTitle"></span>
    </button>
</template>
<script>
    export default{
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: "button"
            },
            disabled: Boolean,
            title: String,
            click: String
        },
        computed: {
            currentTitle() {
                return this.loading ? "<i class='fa fa-refresh fa-spin fa-fw'></i>" : this.title;
            },
            isDisabled() {
                return this.disabled || this.loading;
            }
        },
        methods: {
            clicked(e) {
                this.$emit('clicked', e, this.click);
            }
        }
    }
</script>
